import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, c = /* @__PURE__ */ o("path", { d: "m6.846 30.663 1.353 1.359a.923.923 0 0 0 1.035.207.946.946 0 0 0 .3-.207l15-15 15 14.985c.085.09.187.16.3.21a.977.977 0 0 0 .735 0 .955.955 0 0 0 .3-.21l1.353-1.356a.963.963 0 0 0 0-1.356l-17.7-17.7L6.804 29.316a.96.96 0 0 0 0 1.353l.042-.006Z" }, null, -1), l = [
  c
];
function r(s, a) {
  return e(), t("svg", n, l);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
//# sourceMappingURL=chevron-up.svg.mjs.map
